import { api } from "@/lib/api";
import { toast } from "sonner";

/**
 * Downloads an authenticated PDF (or any binary) as a blob and triggers a save.
 * Necessary because <a href> can't send Authorization headers, and mobile
 * browsers inside iframes block third-party cookies — so anchor-tag downloads
 * fail with 401 in exactly the environments where our users live.
 *
 * @param {string} path - route below /api (e.g. "/provider/rpm/report.pdf")
 * @param {string} filename - suggested filename for the browser
 */
export async function downloadAuthenticatedFile(path, filename) {
  try {
    const res = await api.get(path, { responseType: "blob" });
    const blob = new Blob([res.data], {
      type: res.headers["content-type"] || "application/octet-stream",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      URL.revokeObjectURL(url);
      a.remove();
    }, 0);
  } catch (err) {
    toast.error(err?.response?.data?.detail || "Download failed — please try again");
  }
}
